export const EMAIL_ACCOUNT_STATUS = {
  NO_ACCOUNT_NO_EMAIL: 'no_account_no_email',
  ACCOUNT_EXISTS_NO_PASSWORD: 'account_exists_no_password',
  ACCOUNT_EXISTS_PASSWORD_EXISTS: 'account_exists_password_exists'
};
